import { useEffect, useState } from "react";
import { getStoredUser, storeUser, clearStoredUser } from "../../utils/localStorageUtils"; // 경로는 상황에 맞게

function useLocalStorageVO() {
    const [loginUser, setLoginUser] = useState(getStoredUser);

    useEffect(() => {
        storeUser(loginUser);
    }, [loginUser]);

    const setUserInfo = (auth, isBranchManagerLogin = false) => {
        setLoginUser({
            id: auth.id,
            site: auth.site,
            compCd: auth.compCd,
            loginId: auth.loginId,
            userNm: auth.userNm,
            userEmail: auth.email,
            userRole: auth.roleId,
            roleNm: auth.roleNm,
            priorityLevel: auth.priorityLevel,
            isBranchManagerLogin: isBranchManagerLogin // 지부장 로그인 여부
        });
    };

    const logout = () => {
        let navigate = isBranchManagerLoginUser() ? "/admin" : "/login"
        clearStoredUser();
        setLoginUser(getStoredUser());
        setTimeout(() => window.location.href = navigate, 100);
    };

    const isLogin = () => loginUser.id !== null && loginUser.loginId !== null;
    const isDev = (): boolean => loginUser.priorityLevel === 5
    const isAdmin = ():boolean => loginUser.priorityLevel >= 3
    const isBranchManagerLoginUser = (): boolean => loginUser.isBranchManagerLogin === true

    return { setUserInfo, logout, loginUser, isLogin, isDev, isAdmin, isBranchManagerLoginUser };
}

export default useLocalStorageVO;